enum FileNodeViewTypes {
  MAP = 'MAP',
  VIEWER = 'VIEWER',
}
export default FileNodeViewTypes;
